import type { FactorFormState, RosterCombineOverrides } from '../../../types/statusFactors';
import { toStored, fromStored } from '../RelatedSpheresEditor/combineModel';

/**
 * The unsaved combine settings (method, weighting, weight floor) the roster rows are computed under, mapped the
 * way a save stores them. `undefined` while none of the three differs from the stored factor, so a clean editor
 * asks the route for the stored roster exactly as before.
 */
export function buildRosterOverrides(
  local: FactorFormState,
  original: FactorFormState | null
): RosterCombineOverrides | undefined {
  if (!original) return undefined;
  const next = toStored(fromStored(local));
  const stored = toStored(fromStored(original));
  const nextFloor = local.influenceFloor ?? null;
  const same =
    next.aggregationMethod === stored.aggregationMethod &&
    next.weighting === stored.weighting &&
    nextFloor === (original.influenceFloor ?? null);
  if (same) return undefined;
  return { aggregationMethod: next.aggregationMethod, weighting: next.weighting, influenceFloor: nextFloor };
}
